<p>{{ messageKey | translate: interpolation }}</p>
<div class="btn-container">
  @if (hasDoNotShowAgainButton) {
    <input type="submit" class="cb-btn no-padding" value="{{'COMMONMESSAGEDIALOG.DONOTSHOWAGAIN' | translate}}" (click)="doNotShowAgainOk()"/>
  }
  <input type="submit" class="cb-btn" value="{{'COMMONMESSAGEDIALOG.CLOSEBUTTON' | translate}}" (click)="ok()"/>
</div>
